import { z } from "zod"

import { powurOsAdderLenderCategorySchema } from "./adder-categories"

export const powurOsProposalAdderPriceSchema = z.object({
  start: z.string(),
  end: z.nullable(z.string()).optional(),
  cost: z.number(),
  description: z.nullable(z.string()).optional(),
  isVariable: z.boolean().optional(),
  maxVariableCost: z.nullable(z.number()).optional(),
})
export type PowurOsProposalAdderPrice = z.infer<
  typeof powurOsProposalAdderPriceSchema
>

export const powurOsProposalAdderCategorySchema = z.object({
  id: z.number().int(),
  name: z.string(),
  allowMultiples: z.boolean().default(true),
})
export type PowurOsAdderCategory = z.infer<
  typeof powurOsProposalAdderCategorySchema
>

export const powurOsProposalAdderSchema = z.object({
  id: z.number().int(),
  category: powurOsProposalAdderCategorySchema,
  description: z.nullable(z.string()),
  lenderCategories: z.array(powurOsAdderLenderCategorySchema),
  lineType: z.number(),
  onContract: z.boolean(),
  order: z.nullable(z.number()),
  priceList: z.array(powurOsProposalAdderPriceSchema),
  proposalDisplayName: z.nullable(z.string()),
  proposalTypeId: z.number().int(),
  proposalUseTypeId: z.number().int(),
  title: z.string(),
  unit: z.number().nullable(),
  watts: z.number(),
})
export type PowurOsProposalAdder = z.infer<typeof powurOsProposalAdderSchema>

export enum PowurOsProposalUseType {
  "None" = 0,
  "Single" = 1,
  "Multiple" = 2,
}
